<template>
  <div class="app-container member-new-edit">
    <basic-container v-loading="loading">
      <div class="operation">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submit">保存</el-button>
      </div>
      <el-row>
        <el-col :span="2">
          <div>头像</div>
        </el-col>
        <el-col :span="12">
          <div>
            <div class="image">
              <img :src="avatarImg" v-show="showAvatar" class="origin-avatar" />
            </div>
            <div class="upload-btn">
              <el-button @click="handleImageChange" size="small" type="primary">{{this.avatarImg ? '重新上传' : '点击上传'}}</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2">
          <div>官方号名称</div>
        </el-col>
        <el-col :span="8">
          <div>
            <el-input v-model.trim="nickname" :maxlength="45"></el-input>
          </div>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="2">
          <div>关联员工号</div>
        </el-col>
        <el-col :span="8">
          <div>
            <el-input v-model.trim="relatedPersonalUnionId" placeholder="多位请用英文逗号隔开"></el-input>
          </div>
        </el-col>
      </el-row> -->
    </basic-container>
  </div>
</template>
<script>
import { addOfficialMember } from '@/api/admin/member'

export default {
  data () {
    return {
      loading: false,
      avatarImg: '',
      nickname: '',
      relatedPersonalUnionId: '',
      showAvatar: false,
    }
  },
  mounted () {
  },
  methods: {
    handleImageRemove () {
      this.avatarImg = null
      this.showAvatar = false
    },
    handleImageChange (file, fileList) {
      this.$openMaterialLib((list) => {
        if (!list || list.length === 0) {
          return;
        }
        this.avatarImg = list[0].contentUrl
        this.showAvatar = true
      }, 1);
    },
    validate () {
      if (!this.avatarImg) {
        this.$message({
          message: '官方号头像不能为空',
          type: 'error'
        })
        return false
      }
      if (!this.nickname) {
        this.$message({
          message: '官方号名称不能为空',
          type: 'error'
        })
        return false
      }
      return true
    },
    getParams () {
      return {
        avatar: this.avatarImg,
        nickname: this.nickname,
        relatedPersonalUnionId: this.relatedPersonalUnionId,
      }
    },
    cancel () {
      this.$router.$avueRouter.closeTag()
      this.$router.go(-1)
    },
    submit () {
      if (!this.validate()) {
        return false
      }
      addOfficialMember(this.getParams()).then(response => {
        if (response.data.code === 0) {
          this.$message({
            message: '创建成功',
            type: 'success'
          })
          this.$router.$avueRouter.closeTag()
          this.$router.push({
            path: `/upms/member/official/detail/${response.data.data}`,
          })
        } else {
          this.$message({
            message: response.data.msg,
            type: 'error'
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.member-new-edit {
  .image{
    position: relative;
    width: 148px;
    .origin-avatar {
      width: 148px;
      height: 148px;
      float: left;
      margin-right: 8px;
      border-radius: 50%;
    }
  }
  .upload-btn {
    display: flex;
    width: 148px;
    height: 148px;
    border: 3px #E4E7ED dashed;
    text-align: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    justify-content: center;
    align-content: center;
  }
  .operation {
    text-align: right
  }
}
/deep/ .el-upload-list__item-thumbnail {
  border-radius: 50%;
}
</style>
